module.exports = require('./bundle-url').getBundleURL() + "plocklebrowser.f63a24a2.webm"